<div class="page-innder-body portlet light ">
  <div class="portlet-body">
    <!-- Skeleton Loader -->
    @if (adminsLoading) {
      <div class="skeleton-loader">
        <div class="d-flex justify-content-between align-items-center py-3" style="border-bottom: 1px solid #e9ecef;">
          <div class="skeleton" style="width: 150px; height: 28px;"></div>
          <div class="skeleton" style="width: 140px; height: 36px; border-radius: 6px;"></div>
        </div>
        <div class="skeleton" style="width: 50%; height: 40px; border-radius: 6px; margin: 16px 0;"></div>
        <div class="d-flex py-2" style="border-bottom: 1px solid #e9ecef; gap: 16px;">
          @for (i of [1,2,3,4,5,6]; track i) {
            <div class="skeleton" style="width: 16%; height: 18px;"></div>
          }
        </div>
        @for (i of [1,2,3,4,5,6,7,8]; track i) {
          <div class="d-flex py-3" style="border-bottom: 1px solid #f1f5f9; gap: 16px;">
            @for (j of [1,2,3,4,5,6]; track j) {
              <div class="skeleton" style="width: 16%; height: 16px;"></div>
            }
          </div>
        }
      </div>
    }

    @if (!adminsLoading) {
      <div class="table-toolbar">
        <div class="row">
          <div class="col-md-12">
            <p-toolbar>
              <div class="p-toolbar-group-start" style="font-size:x-large;">{{ 'admins.viewAdmins' | transloco }}</div>
              <div class="p-toolbar-group-end">
                <p-button type="button" icon="fa fa-plus" [label]="'admins.addNewAdmin' | transloco" [outlined]="true"
                (click)="onShowAdminDailog()"></p-button>
              </div>
            </p-toolbar>
          </div>
        </div>
      </div>
      <div class="table-responsive mt-3">
        <p-table #dt [value]="admins" dataKey="id" [rowHover]="true"
          styleClass="p-datatable-gridlines p-datatable-striped"
          [globalFilterFields]="['Name', 'Email', 'PhoneNumber']" selectionMode="single" [paginator]="admins.length >15"
          [rows]="15" [reorderableColumns]="true" [resizableColumns]="false">
          <ng-template pTemplate="caption">
            <div class="table-header">
              <div class="row">
                <div class="col-md-6 text-right">
                  <div
                    class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                    <button type="button"
                      class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                      <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                    </button>
                    <input type="text"
                      class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                      (input)="dt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'admins.searchPlaceholder' | transloco" />
                    </div>
                  </div>
                  <div class="col-md-6 text-left"></div>
                </div>
              </div>
            </ng-template>
            <ng-template let-rowIndex="rowIndex" pTemplate="header" let-rowData>
              <tr>
                <th [pSortableColumn]="'Name'">{{ 'admins.adminName' | transloco }} <p-sortIcon [field]="'Name'"></p-sortIcon></th>
                <th [pSortableColumn]="'Email'">{{ 'admins.email' | transloco }} <p-sortIcon [field]="'Email'"></p-sortIcon></th>
                <th [pSortableColumn]="'PhoneNumber'">{{ 'admins.phoneNumber' | transloco }} <p-sortIcon [field]="'PhoneNumber'"></p-sortIcon></th>
                <th [pSortableColumn]="'BusinessName'">{{ 'admins.business' | transloco }} <p-sortIcon [field]="'Bussiness'"></p-sortIcon></th>
                <th [pSortableColumn]="'CreatedDate'">{{ 'admins.created' | transloco }} <p-sortIcon [field]="'CreatedDate'"></p-sortIcon></th>
                <th>{{ 'admins.actions' | transloco }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
              <tr>
                <td>
                  <div class="form-group align-items-center">
                    <img [src]="rowData.ImgUrl ? rowData.ImgUrl : 'assets/images/No-Image.png'" class="rounded-circle me-1"
                      style="width: 25px; height: 25px; object-fit: cover;" />
                      <span class="text-uppercase">{{rowData.Name}}</span>
                    </div>
                  </td>
                  <td>{{rowData.Email}}</td>
                  <td>
                    {{rowData.PhoneNumber}}
                  </td>
                  <td>
                    {{rowData.BusinessName}}
                    <div class="text-muted small">{{rowData.BusinessNumber}}</div>
                  </td>
                  <td>{{rowData.CreatedDate | date: 'dd/MM/yyyy HH:mm'}}</td>
                  <td>
                    <!-- Action Buttons -->
                    <div style="display: flex; align-items: center;">
                      <button pButton (click)="onEditAdmin(rowData.Id)" class="p-button p-button-sm me-1 p-button-outlined"
                      icon="pi pi-pencil" size="small"></button>
                      <button pButton (click)="onDeleteAdmin(rowData.Id)"
                      class="p-button-danger p-button-sm me-1 p-button-outlined" icon="pi pi-trash" size="small"></button>
                      <button pButton icon="fa fa-sign-in" class="p-button-sm me-1 p-button-outlined" (click)="switchAccount(rowData)"
                        [pTooltip]="'admins.switchAccount' | transloco" tooltipPosition="top">
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="6">
                    <div class="text-center">{{ 'admins.noAdminRecords' | transloco }}</div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }

      </div>
    </div>

    <p-dialog [header]="isEditMode ? ('admins.editAdmin' | transloco) : ('admins.addAdmin' | transloco)" [(visible)]="isadminDialogvisible" [modal]="true"
      [style]="{ 'width': '560px' }" (onHide)="oncloseAdminDialog()">
      <div class="p-fluid p-2">
        <form class="form-horizontal">
          <p-tabView [(activeIndex)]="selectedTabIndex">
            <p-tabPanel [header]="'admins.personalInformation' | transloco">
              <div class="form-group mt-2 text-center">
                @if (!adminFormData.ImgUrl) {
                  <div class="input-group justify-content-center">
                    <p-fileUpload #fileUpload name="LogoFile" (onSelect)="onFileSelected($event.files, 'AdminImgUrl')"
                    [chooseLabel]="'admins.adminProfileImage' | transloco" [auto]="true" mode="basic"></p-fileUpload>
                  </div>
                }

                @if (adminFormData.ImgUrl) {
                  <div class="position-relative d-inline-block mt-3">
                    <!-- Display uploaded image with rounded corners and shadow -->
                    <img [src]="adminFormData.ImgUrl" class="rounded-circle img-thumbnail"
                      style="width: 100px; height: 100px; object-fit: cover; border: 2px solid #fff; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);" />
                      <div class="position-absolute top-0 end-0 m-2">
                        <button type="button" class="btn btn-sm btn-danger p-button-outlined"
                          (click)="removeImg('ImgUrl')">
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                    </div>
                  }
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group mt-3">
                      <label for="FirstName"><span class="text-danger me-1">*</span>{{ 'admins.adminFirstName' | transloco }}</label>
                      <input type="text" id="FirstName" pInputText [placeholder]="'admins.adminFirstName' | transloco" class="form-control form-control-sm"
                        [(ngModel)]="adminFormData.FirstName" name="FirstName" required />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group mt-3">
                        <label for="LastName"><span class="text-danger me-1">*</span>{{ 'admins.adminLastName' | transloco }}</label>
                        <input type="text" id="LastName" pInputText [placeholder]="'admins.adminLastName' | transloco" class="form-control form-control-sm"
                          [(ngModel)]="adminFormData.LastName" name="LastName" required />
                        </div>
                      </div>
                    </div>
                    <!-- <div class="form-group mt-3">
                    <label for="fullName"><span class="text-danger me-1">*</span>Admin Name</label>
                    <input type="text" id="fullName" pInputText placeholder="Admin Name" class="form-control form-control-sm"
                      [(ngModel)]="adminFormData.Name" name="fullName" required />
                    </div> -->
                    <div class="form-group mt-2">
                      <label for="email" class="form-label"><span class="text-danger me-1">*</span>{{ 'admins.email' | transloco }}</label>
                      <input id="email" type="email" pInputText [placeholder]="'admins.email' | transloco" class="form-control form-control-sm"
                        [(ngModel)]="adminFormData.Email" name="email" required />
                      </div>
                      <div class="form-group mt-2">
                        <label for="phoneNumber" class="form-label"><span class="text-danger me-1">*</span>{{ 'admins.phoneNumber' | transloco }}</label>
                      <input id="phoneNumber" type="tel" pInputText [placeholder]="'admins.phoneNumber' | transloco"
                        class="form-control form-control-sm" [(ngModel)]="adminFormData.PhoneNumber" name="phoneNumber" required />
                      </div>
                      <div class="form-group mt-2">
                        <label for="MobileNumber" class="form-label"><span class="text-danger me-1">*</span>{{ 'admins.mobileNumber' | transloco }}</label>
                      <input id="MobileNumber" type="text" pInputText [placeholder]="'admins.mobileNumber' | transloco"
                        class="form-control form-control-sm" [(ngModel)]="adminFormData.MobileNumber" name="MobileNumber" required />
                      </div>
                      <div class="form-group mt-2">
                        <label class="form-label" for="ABN">{{ 'admins.abn' | transloco }}</label>
                        <input id="Suburb" pInputText [placeholder]="'admins.abn' | transloco" class="form-control form-control-sm"
                          [(ngModel)]="adminFormData.ABN" name="ABN" required />
                        </div>
                        <div class="form-group mt-2">
                          <label class="form-label" for="FacebookLink">{{ 'admins.facebookLink' | transloco }}</label>
                          <input id="FacebookLink" pInputText [placeholder]="'admins.facebookLink' | transloco" class="form-control form-control-sm"
                            [(ngModel)]="adminFormData.FacebookLink" name="FacebookLink" required />
                          </div>
                          <div class="form-group mt-2">
                            <label class="form-label" for="InstagramLink">{{ 'admins.instagramLink' | transloco }}</label>
                            <input id="InstagramLink" pInputText [placeholder]="'admins.instagramLink' | transloco" class="form-control form-control-sm"
                              [(ngModel)]="adminFormData.InstagramLink" name="InstagramLink" required />
                            </div>
                            <div class="form-group mt-2">
                              <label class="form-label" for="LinkedinLink">{{ 'admins.linkedinLink' | transloco }}</label>
                              <input id="LinkedinLink" pInputText [placeholder]="'admins.linkedinLink' | transloco" class="form-control form-control-sm"
                                [(ngModel)]="adminFormData.LinkedinLink" name="LinkedinLink" required />
                              </div>
                            </p-tabPanel>
                            <p-tabPanel [header]="'admins.bank' | transloco">
                              <div class="form-group mt-2">
                                <label for="bankName" class="form-label"><span class="text-danger me-1">*</span>{{ 'admins.bankName' | transloco }}</label>
                                <input type="text" id="bankName" pInputText [placeholder]="'admins.bankName' | transloco" class="form-control form-control-sm"
                                  [(ngModel)]="adminFormData.BankName" name="bankName" required />
                                </div>
                                <div class="form-group mt-2">
                                  <label for="accountNumber" class="form-label"><span class="text-danger me-1">*</span>{{ 'admins.bankAccountNumber' | transloco }}</label>
                                  <input type="text" id="accountNumber" pInputText [placeholder]="'admins.accountNumber' | transloco"
                                    class="form-control form-control-sm" [(ngModel)]="adminFormData.AccountNumber" name="accountNumber" required />
                                  </div>
                                  <div class="form-group mt-2">
                                    <label class="form-label" for="bankAddress"><span class="text-danger me-1">*</span>{{ 'admins.bankAddress' | transloco }}</label>
                                    <input type="text" id="bankAddress" pInputText [placeholder]="'admins.bankAddress' | transloco"
                                      class="form-control form-control-sm" [(ngModel)]="adminFormData.BankAddress" name="bankAddress" />
                                    </div>
                                    <div class="form-group p-field mt-2">
                                      <label class="form-label" for="bankBSB">{{ 'admins.bankBsb' | transloco }}</label>
                                      <input type="text" id="bankBSB" pInputText [placeholder]="'admins.bankBsb' | transloco" class="form-control form-control-sm"
                                        [(ngModel)]="adminFormData.BankBSB" name="bankBSB" />
                                      </div>
                                    </p-tabPanel>
                                    <p-tabPanel [header]="'admins.address' | transloco">
                                      <div class="form-group p-field mt-2">
                                        <label class="form-label" for="addressLine1">{{ 'admins.addressLine1' | transloco }}</label>
                                        <input type="text" id="addressLine1" pInputText [placeholder]="'admins.addressLine1' | transloco"
                                          class="form-control form-control-sm" [(ngModel)]="adminFormData.AddressLine1" name="addressLine1" />
                                        </div>
                                        <div class="form-group p-field mt-2">
                                          <label class="form-label" for="addressLine2">{{ 'admins.addressLine2' | transloco }}</label>
                                          <input type="text" id="addressLine2" pInputText [placeholder]="'admins.addressLine2' | transloco"
                                            class="form-control form-control-sm" [(ngModel)]="adminFormData.AddressLine2" name="addressLine2" />
                                          </div>
                                          <div class="form-group p-field mt-2">
                                            <label class="form-label" for="StreetAddress">{{ 'admins.streetAddress' | transloco }}</label>
                                            <input type="text" id="StreetAddress" pInputText [placeholder]="'admins.streetAddress' | transloco"
                                              class="form-control form-control-sm" [(ngModel)]="adminFormData.StreetAddress" name="StreetAddress" />
                                            </div>
                                            <div class="form-group p-field mt-2">
                                              <label class="form-label" for="Suburb">{{ 'admins.suburb' | transloco }}</label>
                                              <input id="Suburb" pInputText [placeholder]="'admins.suburb' | transloco" class="form-control form-control-sm"
                                                [(ngModel)]="adminFormData.Suburb" name="Suburb" required />
                                              </div>
                                              <div class="form-group p-field mt-2">
                                                <label class="form-label" for="State">{{ 'admins.state' | transloco }}</label>
                                                <input type="text" id="State" pInputText [placeholder]="'admins.state' | transloco" class="form-control form-control-sm"
                                                  [(ngModel)]="adminFormData.State" name="State" />
                                                </div>
                                                <div class="form-group p-field mt-2">
                                                  <label class="form-label" for="PostCode">{{ 'admins.postCode' | transloco }}</label>
                                                  <input type="text" id="PostCode" pInputText [placeholder]="'admins.postCode' | transloco" class="form-control form-control-sm"
                                                    [(ngModel)]="adminFormData.PostCode" name="PostCode" />
                                                  </div>
                                                </p-tabPanel>
                                                <p-tabPanel [header]="'admins.business' | transloco">
                                                  <div class="form-group mt-3">
                                                    @if (!adminFormData.BusinessLogoUrl) {
                                                      <div class="input-group justify-content-center">
                                                        <p-fileUpload #buissnesslogo name="LogoFile" (onSelect)="onFileSelected($event.files, 'BusinessLogoUrl')"
                                                        [chooseLabel]="'admins.adminBusinessLogo' | transloco" [auto]="true" mode="basic"></p-fileUpload>
                                                      </div>
                                                    }


                                                    @if (adminFormData.BusinessLogoUrl) {
                                                      <div class="position-relative text-center mt-2">
                                                        <div style="position: relative; display: inline-block;">
                                                          <img [src]="adminFormData.BusinessLogoUrl"
                                                            style="width: 80px; height: 80px; object-fit: cover; border-radius: 50%; border: 5px solid #fff; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);"
                                                            class="mx-auto d-block" />
                                                            <button type="button"
                                                              class="btn btn-sm btn-danger p-button-outlined position-absolute top-0 end-0 m-2"
                                                              style="z-index: 1;" (click)="removeImg('BusinessLogoUrl')">
                                                              <i class="fa fa-times"></i>
                                                            </button>
                                                          </div>
                                                        </div>
                                                      }
                                                    </div>
                                                    <div class="form-group mt-3">
                                                      <label for="BusinessName" class="form-label">{{ 'admins.businessName' | transloco }}</label>
                                                      <input type="text" id="BusinessName" pInputText [placeholder]="'admins.businessName' | transloco"
                                                        class="form-control form-control-sm" [(ngModel)]="adminFormData.BusinessName" name="BusinessName" required />
                                                      </div>
                                                      <div class="form-group mt-2">
                                                        <label for="BusinessNumber" class="form-label"><span class="text-danger me-1">*</span>{{ 'admins.businessNumber' | transloco }}</label>
                                                        <input type="text" id="BusinessNumber" pInputText [placeholder]="'admins.businessNumber' | transloco"
                                                          class="form-control form-control-sm" [(ngModel)]="adminFormData.BusinessNumber" name="BusinessNumber" />
                                                        </div>
                                                        <div class="form-group mt-2">
                                                          <label class="form-label" for="BusinessFacebookLink">{{ 'admins.businessFacebookLink' | transloco }}</label>
                                                          <input id="BusinessFacebookLink" pInputText [placeholder]="'admins.businessFacebookLink' | transloco"
                                                            class="form-control form-control-sm" [(ngModel)]="adminFormData.BusinessFacebookLink"
                                                            name="BusinessFacebookLink" required />
                                                          </div>
                                                          <div class="form-group mt-2">
                                                            <label class="form-label" for="BusinessInstagramLink">{{ 'admins.businessInstagramLink' | transloco }}</label>
                                                            <input id="BusinessInstagramLink" pInputText [placeholder]="'admins.businessInstagramLink' | transloco"
                                                              class="form-control form-control-sm" [(ngModel)]="adminFormData.BusinessInstagramLink"
                                                              name="BusinessInstagramLink" required />
                                                            </div>
                                                            <div class="form-group mt-2">
                                                              <label class="form-label" for="BusinessLinkedinLink">{{ 'admins.businessLinkedinLink' | transloco }}</label>
                                                              <input id="BusinessLinkedinLink" pInputText [placeholder]="'admins.businessLinkedinLink' | transloco"
                                                                class="form-control form-control-sm" [(ngModel)]="adminFormData.BusinessLinkedinLink"
                                                                name="BusinessLinkedinLink" required />
                                                              </div>
                                                            </p-tabPanel>
                                                          </p-tabView>
                                                          <div>
                                                            <button pButton type="button" [disabled]="!adminFormData.FirstName || !adminFormData.LastName || !adminFormData.Email || !adminFormData.PhoneNumber || !adminFormData.MobileNumber" (click)="onSaveAdmin()" [label]="'admins.saveChanges' | transloco" class="p-button-outlined"></button>
                                                          </div>
                                                        </form>
                                                      </div>
                                                    </p-dialog>

                                                    @if (showCropperDialog) {
                                                      <app-image-cropper
                                                        [image]="currentSelectedImageToCrop"
                                                        [showCropperDialog]="showCropperDialog"
                                                        (onImageCropped)="onImageCropped($event)"
                                                        (onImageCropperClose)="onImageCropperClose($event)">
                                                      </app-image-cropper>
                                                    }